// extracted by mini-css-extract-plugin
export default {"block":"IconClose_block__2l315","blockBig":"IconClose_blockBig__IyF4N","icon":"IconClose_icon__Yetbs","blockSmall":"IconClose_blockSmall__8Bl86"};